/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_ReligionInputs */



/**
* | output |
* | --- |
* | "Religion" |
*
* @param {Subtitle_Export_Keyword_ReligionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_religion = /** @type {((inputs?: Subtitle_Export_Keyword_ReligionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_ReligionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Religion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Religion")
	if (locale === "it") return /** @type {LocalizedString} */ ("Religione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Религия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Religión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("宗教")
	if (locale === "ja") return /** @type {LocalizedString} */ ("宗教")
	if (locale === "hi") return /** @type {LocalizedString} */ ("धर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Religião")
	return /** @type {LocalizedString} */ ("Religion")
});